import React, { useEffect } from "react";
import { Form, Icon } from "semantic-ui-react";
import PhotoUploader from "./PhotoUploader";
import usePhoto from "@common/components/hooks/usePhoto";
import CustomerPhotoCrop from "../CustomerPhotoCrop";
import CameraWrapper from "@common/components/shared/CameraWrapper";

export default function PhotoComponent({
  name,
  label = "",
  labelClass = "w-30",
  error = null,
  photoSize = 200,
  fieldStyle = "flex-row-center gap-1",
  contentStyle = "flex-left-0_25 w-100",
  inputStyle = "border-grey-1 p-1 clickable text-center",
  onSubmit = () => {},
}) {
  const { showCamera, updatePhoto, toggleCamera, showCropper } = usePhoto();

  useEffect(() => {
    if (updatePhoto && !showCropper) onSubmit();
  }, [updatePhoto, showCropper]);

  return (
    <>
      <Form.Field name={name} className={fieldStyle} error={!!error}>
        {label && <label className={labelClass}>{label}</label>}
        <div className={contentStyle}>
          <CustomerPhotoCrop size={photoSize} />
          <div
            className="flex space-between gap-0_25"
            style={{ height: photoSize }}
          >
            <div className={inputStyle} onClick={() => toggleCamera(true)}>
              <Icon className="m-a" name="camera" />
              <p className="mt-0_5 text-12px">Take Photo</p>
            </div>
            <div className={inputStyle}>
              <PhotoUploader />
            </div>
          </div>
        </div>
      </Form.Field>
      {showCamera && <CameraWrapper />}
    </>
  );
}
